import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Logs } from '@classes/logs/logs';
import { faVideo } from '@fortawesome/free-solid-svg-icons';
import { LogsService } from '@services/logs/logs.service';

@Component({
  selector: 'app-allview',
  templateUrl: './allview.component.html',
  styleUrls: ['./allview.component.scss']
})
export class AllviewComponent implements OnInit {

  lat = 50.597551;
  lng = 3.403683;
  logs: Logs[];
  alerte: string;
  choiceDateForm: UntypedFormGroup;
  today = new Date();
  tab = 'camera';

  displayedColumns: string[] = ['name', 'alerte', 'date', 'source'];
  dataSource: MatTableDataSource<Logs>;

  z

  markersWaste = [
    {
      lat: 50.597546,
      lng: 3.403655,
      label: 'Alerte 1',
      iconUrl: "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
    },
    {
      lat: 50.602996,
      lng: 3.403978,
      label: 'Alerte 2',
      iconUrl: "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
    },
    {
      lat: 50.614796,
      lng: 3.387345,
      label: 'Alerte 3',
      iconUrl: "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
    },
    {
      lat: 50.593115,
      lng: 3.404552,
      label: 'Alerte 4',
      iconUrl: "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
    }

  ];

  CameraWaste = [
    {
      lat: 50.517546,
      lng: 3.403655,
      label: 'Caméra 1',
      iconUrl: "assets/img/camera.svg"
    },
    {
      lat: 50.532996,
      lng: 3.403978,
      label: 'Caméra 2',
      iconUrl: "assets/img/camera.svg"
    },
    {
      lat: 50.584796,
      lng: 3.378345,
      label: 'Caméra 3',
      iconUrl: "assets/img/camera.svg"
    },
    {
      lat: 50.523115,
      lng: 3.384552,
      label: 'Caméra 4',
      iconUrl: "assets/img/camera.svg"
    }

  ];

  constructor(

    private logsService: LogsService,
    private formBuilder: UntypedFormBuilder
  ) {

  }
  ngOnInit(): void {

    // this.getLogs();
    this.initForm();

  }
  onSubmit(changeCamera: boolean): void {

  }



  changeValueInputFrom(): void {
    const dateFrom = new Date(this.choiceDateForm.get('from').value).getTime();
    const dateTo = new Date(this.choiceDateForm.get('to').value).getTime();

    const date = new Date(this.choiceDateForm.get('to').value);
    date.setDate(date.getDate() - 7);

    if (dateTo <= dateFrom) {
      this.choiceDateForm.get('from').setValue(date);

    }
  }

  setTab(tab: string): void {
    this.tab = tab;
  }


  // private getLogs(): void {

  //   this.logs = this.logsService.logs;
  //   this.dataSource = new MatTableDataSource<Logs>(this.logs);

  // }
  private initForm(): void {
    const date = new Date();
    date.setDate(date.getDate() - 7);
    this.choiceDateForm = this.formBuilder.group({

      from: [date, Validators.required],
      to: [this.today, Validators.required]
    });




  }
}
